import {
  BarChartRounded,
  DashboardRounded,
  FlashOn,
  MultilineChartRounded,
  PublicRounded,
  SsidChartRounded,
  TrendingUpRounded,
} from "@mui/icons-material";

export const sidebarData = [
  {
    id: "dashboard",
    title: "داشبورد",
    icon: <DashboardRounded />,
    link: "/dashboard",
    // items: [
    //   {
    //     route: "dashboard",
    //     label: "داشبورد",
    //     link: "/dashboard",
    //   },
    // ],
  },
  {
    id: "recommended",
    title: "سهام پیشرو",
    icon: <FlashOn sx={{ width: "24px" }} />,
    link: "/dashboard/recommended",
  },
  {
    id: "market-watch",
    title: "تابلو خوانی",
    icon: <BarChartRounded sx={{ width: "24px" }} />,
    items: [
      {
        route: "stocks",
        label: "تابلو سهام",
        link: "/dashboard/market-watch/stocks",
      },
      {
        route: "options",
        label: "تابلو آپشن",
        link: "/dashboard/market-watch/options",
      },
    ],
  },
  {
    id: "derivatives",
    title: "ابزارهای مشتقه",
    icon: <TrendingUpRounded sx={{ width: "24px" }} />,
    items: [
      {
        route: "commodity-market",
        label: "بورس کالا",
        link: "/dashboard/derivatives/commodity-market",
      },
      {
        route: "stock-option",
        label: "آپشن سهام",
        link: "/dashboard/derivatives/stock-option",
      },
    ],
  },
  {
    id: "domestic-market",
    title: "بورس کالای داخلی",
    icon: <MultilineChartRounded sx={{ width: "24px" }} />,
    items: [
      {
        route: "top-price-changes",
        label: "بیشترین تغییرات قیمت کالا",
        link: "/dashboard/domestic-market/top-price-changes",
      },
      {
        route: "product-price-chart",
        label: "نمودار قیمتی کالا",
        link: "/dashboard/domestic-market/product-price-chart",
      },
      {
        route: "spread-price",
        label: "اسپرد قیمتی کالا",
        link: "/dashboard/domestic-market/spread-price",
      },
      {
        route: "monthly-stock-sales",
        label: "مبلغ فروش ماهانه کالا",
        link: "/dashboard/domestic-market/monthly-stock-sales",
      },
    ],
  },
  {
    id: "global-market",
    title: "بازارهای جهانی",
    icon: <PublicRounded sx={{ width: "24px" }} />,
    items: [
      {
        route: "top-price-changes",
        label: "بیشترین تغییرات قیمت کالا",
        link: "/dashboard/global-market/top-price-changes",
      },
      {
        route: "product-price-chart",
        label: "نمودار قیمتی کالا",
        link: "/dashboard/global-market/product-price-chart",
      },
      {
        route: "spread-price",
        label: "اسپرد قیمتی کالا",
        link: "/dashboard/global-market/spread-price",
      },
    ],
  },
  {
    id: "roi",
    title: "مقایسه بازدهی",
    icon: <SsidChartRounded sx={{ width: "24px" }} />,
    items: [
      {
        route: "roi-stock",
        label: "بازدهی به تفکیک سهام",
        link: "/dashboard/roi/roi-stock",
      },
      {
        route: "roi-industry",
        label: "بازدهی به تفکیک صنعت",
        link: "/dashboard/roi/roi-industry",
      },
      {
        route: "roi-personal-watch",
        label: "دیده‌بان شخصی",
        link: "/dashboard/roi/roi-personal-watch",
      },
    ],
  },
];
